import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { CourseDayItem } from '.';
export const CourseDays = ({ days, apiClient, classObject, onClickLesson }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) }, days.map((day, i) => (React.createElement(CourseDayItem, { key: i, day: day, apiClient: apiClient, classObject: styles.day, onClick: onClickLesson })))));
};
const styles = StyleSheet.create({
    container: {},
    day: {
        marginTop: 16,
    },
});
